import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { StoreService } from 'src/app/services/store-service/store.service';

@Component({
    selector: 'app-mm-search-store',
    templateUrl: './mm-search-store.component.html',
    styleUrls: ['./mm-search-store.component.scss'],
})
export class MmSearchStoreComponent implements OnInit {
    // @Output() toEventDismiss: EventEmitter<any> = new EventEmitter();

    @Input() formBusca: any;
    @Input() vitrine: any = null;
    @Input() nomatizedParams: any;

    public listFormat: any;
    public classList: any;
    public minPts = 0;
    public maxPts = 100;


    public categorias: any = {};
    public shownGroup: any;
    public showCategorias = false;

    showFiltros = false;

    constructor(private storeService: StoreService,
        private router: Router,
        private modelLocator: ModelLocatorService) { }

    async ngOnInit() {
        await this.getCategorias();
    }


    async getCategorias() {
        await this.storeService.getCategorys(this.modelLocator.dadosLogin.ltm_id).then((data: any) => {
            if (data['status'] === 200) {
                this.categorias = data['result'];
            }
        }).catch((err: any) => {
            console.log("🚀 ~ file: store.page.ts:94 ~ StorePage ~ awaitthis.storeService.getProducts ~ err:", err)
        })

    }

    buscar() {
        console.log('formBusca', this.formBusca);
        this.router.navigate(['/store/store-list-product/busca/' + this.formBusca.busca]);
    }

    abreSubcategoria(tipo: string, obj: any) {
        if (tipo === 'categoria') {
            this.router.navigate(['/store/store-list-product/' + this.string_to_slug(obj.name) + '/' + obj.id]);
        } else {
            this.router.navigate(['/store/store-list-product/' + tipo + '/' + obj.id]);
        }
    }

    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            this.shownGroup = null;
        } else {
            this.shownGroup = group;
        }
    }

    isGroupShown(group) {
        return this.shownGroup === group;
    }

    rangePontos(event) {
        this.nomatizedParams.minPrice = event.detail.value.lower;
        this.nomatizedParams.maxPrice = event.detail.value.upper;
    }

    visual(tipo: any) {
        if (tipo.value === 'LISTA') {
            this.listFormat = '12';
            this.classList = 'liststyle';
        }
        if (tipo.value === 'GRADE') {
            this.listFormat = '6';
            this.classList = 'gridstyle';
        }
    }

    selecionaFiltro(tipo, value) {
        if (value.isChecked === true) {
            this.nomatizedParams[tipo].push(value.id);
        } else {
            for (let i = 0; i < this.nomatizedParams[tipo].length; i++) {
                if (this.nomatizedParams[tipo][i] === value.id) {
                    this.nomatizedParams[tipo].splice(i, 1);
                }
            }
        }
        this.buscar();
    }

    string_to_slug(str) {

        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
        const to = 'aaaaaaeeeeiiiioooouuuunc------';

        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes
            .replace(/^-+/, '') // trim - from start of text
            .replace(/-+$/, ''); // trim - from end of text

        return str;
    }
}
